/**
 * Is there an earlier entry IN THIS APP that a "Back" pop would land on?
 *
 * React Router keys a first location "default", but that is not enough: a
 * REPLACE (e.g. the sign-in callback's `navigate(returnTo, { replace: true })`)
 * gives the first page a non-default key with nothing in-app behind it, and a
 * pop then leaves the app — or does nothing in a fresh tab. The router's
 * BrowserRouter stamps an `idx` on every entry it creates, and that index is
 * the honest answer. Router-free on purpose: the design system knows no
 * router, it only reads what the host's router wrote.
 */
export function hasEarlierInAppEntry(): boolean {
  const state: unknown = window.history.state;
  const idx =
    typeof state === "object" && state !== null
      ? (state as { idx?: unknown }).idx
      : undefined;
  return typeof idx === "number" && idx > 0;
}
